import { render } from "./getReward.vue?vue&type=template&id=c30149cc&scoped=true"
import script from "./getReward.vue?vue&type=script&lang=js"
export * from "./getReward.vue?vue&type=script&lang=js"

import "./getReward.vue?vue&type=style&index=0&id=c30149cc&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/dbc-website-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c30149cc"]])

export default __exports__